import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import SearchBar from "material-ui-search-bar";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";

// core components
import GridContainer from "components/uikit/Grid/GridContainer.js";
import GridItem from "components/uikit/Grid/GridItem.js";
// import Button from "components/uikit/CustomButtons/Button.js";
import Parallax from "components/uikit/Parallax/Parallax.js";
import styles from "assets/jss/material-kit-react/views/mainPage.js";
// Sections for this page
// import ProductSection from "./Sections/HtmlSection.js";
import { API, graphqlOperation } from "aws-amplify";
import { listShowMains, searchShowBoothItems } from "graphql/queries";
// import SectionTitle from "components/atoms/SectionTitle.js";
import { navigate } from "gatsby";
import ItemCard from "components/atoms/ItemCard";
import { BoothItems, BoothItem } from "components/pages/front/Booth";
import SectionTitle from "components/atoms/SectionTitle";
import RangeSlider from "components/atoms/RangeSlider";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import _ from "lodash";
// import Select from "components/atoms/Select";
import { Button, Card, FormControl, InputLabel } from "@material-ui/core";
import SelectBrand from "components/molecures/SelectBrand";
import SelectBoatType from "components/molecures/SelectBoatType";
import SelectPrice from "components/molecures/SelectPrice";
import SelectSize from "components/molecures/SelectSize";

const useStyles = makeStyles(styles);

const brands = ["すべて", "YAMAHA"];

const options = brands.map((brand) => {
  return { name: brand, value: brand };
});

console.log("options", options);

export default function Main(props) {
  const classes = useStyles();
  const { show } = props;
  const [keyword, setKeyword] = React.useState("");

  const [myExpand, setMyExpand] = React.useState(true);

  const [minSize, setMinSize] = React.useState("");
  const [maxSize, setMaxSize] = React.useState("");

  const [searchBrand, setSearchBrand] = React.useState("");
  const [searchBoatType, setSearchBoatType] = React.useState("");
  const [minPrice, setMinPrice] = React.useState("");
  const [maxPrice, setMaxPrice] = React.useState("");
  const [resultItem, setResultItem] = React.useState([]);

  const handleRequestSearch = () => get();

  const get = async () => {
    //全角を半角に変換
    const keywordArray = keyword.replace(/　/g, " ").split(" ");
    if (keywordArray.length > 0) {
      const conditions = keywordArray.map((myKeyword) => {
        return {
          or: [
            { name: { wildcard: "*" + myKeyword + "*" } },
            { name: { match: myKeyword } },
            { readingName: { wildcard: "*" + myKeyword + "*" } },
            { readingName: { match: myKeyword } },
            { keyword: { wildcard: "*" + myKeyword + "*" } },
            { description: { wildcard: "*" + myKeyword + "*" } },
            { description: { match: myKeyword } },
          ],
        };
      });

      const filterCondition = [
        {
          price: {
            range: [
              !minPrice ? 0 : Number(minPrice),
              !maxPrice ? 999999999 : Number(maxPrice),
            ],
          },
          height: {
            range: [
              !minSize ? 0 : Number(minSize),
              !maxSize ? 999999999 : Number(maxSize),
            ],
          },
        },
        ...conditions,
      ];

      if (searchBrand !== "") {
        filterCondition.push({ brand: { eq: searchBrand } });
      }

      if (searchBoatType !== "") {
        filterCondition.push({ boatType: { eq: searchBoatType } });
      }

      // console.log("brand:", brand, brands);

      try {
        const ret = await API.graphql(
          graphqlOperation(searchShowBoothItems, {
            filter: {
              and: filterCondition,
              // and: conditions,
            },
          })
        );
        setResultItem(ret?.data?.searchShowBoothItems?.items);
        return;
      } catch (e) {
        console.error(e);
      }
    } else {
      setResultItem([]);
    }
  };

  return (
    <>
      <div style={{ padding: "1rem", backgroundColor: "rgb(247, 249, 249)" }}>
        <div className={classes.container}>
          <Typography variant="h6" style={{ marginBottom: "1rem" }}>
            ブースを検索する
          </Typography>

          <div style={{ padding: "1rem" }}>
            <div>
              <SearchBar
                placeholder="船名を入力してください。"
                value={keyword}
                onChange={(newValue) => setKeyword(newValue)}
                onRequestSearch={handleRequestSearch}
              />
            </div>

            <div style={{ marginTop: "1rem" }}>
              <Accordion
                expanded={myExpand}
                onChange={(event, value) => setMyExpand(value)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="subtitle2">絞り込み</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <FormControl style={{ minWidth: "120px" }}>
                        <InputLabel shrink>メーカー</InputLabel>
                        <SelectBrand
                          value={searchBrand}
                          onChange={(value) => {
                            setSearchBrand(value);
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl style={{ minWidth: "120px" }}>
                        <InputLabel shrink>種別</InputLabel>
                        <SelectBoatType
                          value={searchBoatType}
                          onChange={(value) => {
                            setSearchBoatType(value);
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="subtitle2" gutterBottom>
                        価格
                      </Typography>
                      <FormControl
                        style={{ minWidth: "120px", marginRight: 8 }}
                      >
                        <InputLabel shrink>下限</InputLabel>

                        <SelectPrice
                          value={minPrice}
                          onChange={(value) => {
                            if (value && maxPrice) {
                              if (Number(maxPrice) > Number(value)) {
                                setMinPrice(value);
                              }
                            } else {
                              setMinPrice(value);
                            }
                          }}
                        />
                      </FormControl>
                      <FormControl style={{ minWidth: "120px" }}>
                        <InputLabel shrink>上限</InputLabel>

                        <SelectPrice
                          value={maxPrice}
                          onChange={(value) => {
                            if (minPrice && value) {
                              if (Number(value) > Number(minPrice)) {
                                setMaxPrice(value);
                              }
                            } else {
                              setMaxPrice(value);
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="subtitle2" gutterBottom>
                        サイズ
                      </Typography>

                      <FormControl
                        style={{ maxWidth: "120px", marginRight: 8 }}
                      >
                        <InputLabel shrink>下限</InputLabel>

                        <SelectSize
                          value={minSize}
                          onChange={(value) => {
                            if (value && maxSize) {
                              if (Number(maxSize) > Number(value)) {
                                setMinSize(value);
                              }
                            } else {
                              setMinSize(value);
                            }
                          }}
                        />
                      </FormControl>
                      <FormControl style={{ minWidth: "120px" }}>
                        <InputLabel shrink>上限</InputLabel>

                        <SelectSize
                          value={maxSize}
                          onChange={(value) => {
                            if (minPrice && value) {
                              if (Number(value) > Number(minSize)) {
                                setMaxSize(value);
                              }
                            } else {
                              setMaxSize(value);
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Grid item xs={12}>
                <div style={{ textAlign: "center", margin: "1rem" }}>
                  <Button
                    variant="outlined"
                    size="large"
                    color="primary"
                    onClick={() => handleRequestSearch()}
                  >
                    検索する
                  </Button>
                </div>
              </Grid>
            </div>
          </div>
          <Fade in={resultItem?.length > 0}>
            <div>
              <SectionTitle>検索結果</SectionTitle>
              <BoothItems>
                {resultItem.map((item) => (
                  <BoothItem
                    key={item.id}
                    onClick={() =>
                      navigate(`/${show.slug}/boothitem/${item.id}`)
                    }
                  >
                    <ItemCard data={item} />
                  </BoothItem>
                ))}
              </BoothItems>
            </div>
          </Fade>
        </div>
      </div>
    </>
  );
}
